<script lang="ts">
  import type { Event, Occurrence, Place } from "../types";
  import Sprite from "./sprite.svelte";
  import Countdown from "./countdown.svelte";
  import { eventPath } from "../support/links";
  import { createEventDispatcher } from "svelte";
  import { getNow, getTimeZone } from "../data/clock";
  import Locale from "./locale.svelte";

  export let event: Event;
  export let place: Place | null;
  export let linkBuilder: () => string;
  export let occurences: Occurrence[] = [];
  export let time = getNow();
  export let timeZone = getTimeZone();

  const dispatch = createEventDispatcher();

  function onNavigate() {
    dispatch("navigate");
  }

  // For now, only show one item
  $: countFrom = occurences.length > 0 ? occurences[0].from : null;
  $: closeHref = linkBuilder();
</script>

{#if event}
  <div class="Container">
    <div class="HappeningNow">
      <div class="MainLine">
        <a class="CloseBtn" href={closeHref}>
          <Sprite icon="icon-close" />
          <span class="sr-only">
            <Locale label="eventBanner.close" />
          </span>
        </a>

        <h2 class="Title">
          <a href={eventPath(event)} on:click={onNavigate}>
            {event.title}
            <Sprite icon="icon-chevron-right" />
          </a>
        </h2>
      </div>

      {#if countFrom}
        <div class="Countdown type-body-2">
          <Sprite icon="icon-timelapse" />
          <Countdown deadline={countFrom} {time} {timeZone} />

          {#if place}
            <!-- Avoids bad white space rules -->
            <span>&nbsp;<Locale label="eventBanner.atPlace" vars={{ place: place.title }} /></span>
          {/if}
        </div>
      {:else if place}
        <div class="Countdown type-body-2">
          <Sprite icon="icon-map" />
          <Locale label="eventBanner.atPlace" vars={{ place: place.title }} />
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .Container {
    --inset: 8px;
    left: 0;
    padding-bottom: var(--inset);
    padding-left: max(env(safe-area-inset-left, 0px), var(--inset));
    padding-right: max(env(safe-area-inset-right, 0px), var(--inset));
    padding-top: max(env(safe-area-inset-top, 0px), var(--inset));
    position: absolute;
    right: 0;
    top: 0;
    z-index: 10;
  }

  .HappeningNow {
    background: white;
    align-content: center;
    border-radius: var(--border-radius-large);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24);
  }

  .Title {
    align-items: center;
    display: flex;
    flex: 1 1;
    font-size: calc(var(--sp) * 12);
    font-weight: 600;
    letter-spacing: calc(var(--sp) * 1.5);
    padding: 0 8px 0 12px;
    text-transform: uppercase;
  }

  .MainLine {
    display: flex;
  }

  .CloseBtn {
    border-top-left-radius: var(--border-radius-large);
    background: black;
    display: block;
    flex: 0 0;
    color: white;
    padding: 12px;
  }

  .Title a {
    display: flex;
    flex: 1 1;
    min-height: 40px;
    align-items: center;
    justify-content: space-between;
    text-decoration: none;
  }

  .Countdown {
    align-items: center;
    background: #e6e6e6;
    border-bottom-right-radius: var(--border-radius-large);
    border-bottom-left-radius: var(--border-radius-large);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.1);
    color: black;
    height: 40px;
    display: flex;
    font-weight: 500;
    line-height: 24px;
    padding: 8px 12px;
    white-space: nowrap;
  }

  .Countdown :global(svg) {
    margin-right: 12px;
  }
</style>
